// let SSO_URL = window.location.href;
// SSO_URL = SSO_URL.split('goto=')[1];
// SSO_URL = decodeURIComponent(SSO_URL);

export class AppConstant {
    // public static emailRegexPattern = '^[A-Za-z0-9._%+-]+@(lpl\.com)$';
    public static emailRegexPattern = '^[A-Za-z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$';
    public static GLOBAL_HEADER_NAME = 'Outlook Web Access';
    public static GLOBAL_SERVICE_ERROR_MSG = 'System is currently facing some difficulties. Please retry once or try after some time.';
    public static NON_NUMBER_ERROR_MSG = 'Please Enter Only Number';
    public static TECH_SUPPORT_MSG = 'Please contact the Advisor Technology Support Team for assistance.';
    public static readonly MAX_PASSCODE_ATTEMPTS = 5;
    // public static SSO_URL = SSO_URL;
}
